import { Role } from 'dashboard/models/role';
import { User } from 'dashboard/models/user';
import Action from 'lib/interfaces/Action';

export type RoleActions =
  | Action<RoleActionType.ClearRole, {}>
  | Action<RoleActionType.SetRole, SetRolePayload>
  | Action<RoleActionType.SetUsers, SetUsersPayload>;

export enum RoleActionType {
  ClearRole = 'role/CLEAR_ROLE',
  SetRole = 'role/SET_ROLE',
  SetUsers = 'role/SET_USERS',
}

interface SetRolePayload {
  role: Role;
}

interface SetUsersPayload {
  users: User[];
}

export function clearRole(): Action<RoleActionType.ClearRole> {
  return { type: RoleActionType.ClearRole };
}

export function setRole(role: Role): Action<RoleActionType.SetRole, SetRolePayload> {
  return {
    payload: {
      role,
    },
    type: RoleActionType.SetRole,
  };
}

export function setUsers(users: User[]) {
  return {
    payload: {
      users,
    },
    type: RoleActionType.SetUsers,
  };
}
